module.exports = __webpack_public_path__ + "static/cyndi_guinn-ac4ae8a6d3a79fac6fc24ce4054750ef.jpg";